import { useLocation } from 'react-router-dom';

export const useSafeLocation = () => {
  try {
    return useLocation();
  } catch (error) {
    return null;
  }
};
